import type {
  CheckoutAttemptStatus,
  CheckoutFormInput,
  HistoryPage,
  PublicPress,
  PublicState,
} from "../../shared/types";

async function json<T>(input: RequestInfo | URL, init?: RequestInit): Promise<T> {
  const response = await fetch(input, init);
  const body: unknown = await response.json().catch(() => null);
  if (!response.ok) {
    const message =
      typeof body === "object" && body !== null && "error" in body && typeof body.error === "string"
        ? body.error
        : "Request failed.";
    const error = new Error(message);
    Object.assign(error, { status: response.status, body });
    throw error;
  }
  return body as T;
}

export function getPublicState(signal?: AbortSignal): Promise<PublicState> {
  return json<PublicState>("/api/state", signal ? { signal } : undefined);
}

export function getHistory(page = 1, pageSize = 20, signal?: AbortSignal): Promise<HistoryPage> {
  return json<HistoryPage>(
    `/api/history?page=${page}&pageSize=${pageSize}`,
    signal ? { signal } : undefined,
  );
}

export function getPress(pressNumber: number, signal?: AbortSignal): Promise<PublicPress> {
  return json<PublicPress>(`/api/press/${pressNumber}`, signal ? { signal } : undefined);
}

export function createCheckout(input: CheckoutFormInput): Promise<{ url: string }> {
  return json<{ url: string }>("/api/checkout", {
    method: "POST",
    headers: { "content-type": "application/json" },
    body: JSON.stringify(input),
  });
}

export function getCheckoutStatus(
  attemptId: string,
  signal?: AbortSignal,
): Promise<CheckoutAttemptStatus> {
  return json<CheckoutAttemptStatus>(
    `/api/checkout/${encodeURIComponent(attemptId)}/status`,
    signal ? { signal } : undefined,
  );
}

export function getPublicConfig(): Promise<{
  appEnvironment: string;
  turnstileSiteKey: string | null;
  siteUrl: string;
}> {
  return json("/api/config");
}

export function postAdmin(path: string, body: Record<string, unknown>): Promise<{ ok: boolean }> {
  return json(`/api/admin/${path}`, {
    method: "POST",
    headers: { "content-type": "application/json" },
    body: JSON.stringify(body),
  });
}
